"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var GSIconHeart = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M22.349 6.24c-1.085-2.561-3.483-4.216-6.11-4.216-1.085 0-2.616.283-4.239 1.478-1.622-1.195-3.152-1.478-4.238-1.478h-.001c-2.627 0-5.025 1.654-6.11 4.216a7.4 7.4 0 0 0-.44 4.323c.309 1.581 1.135 3.1 2.387 4.393l.028.029.029.027 4.855 4.56 2.497.035-6.2-5.821C.56 9.402 3.566 3.706 7.761 3.706c1.357 0 2.839.597 4.239 2.025 1.4-1.429 2.882-2.024 4.238-2.024 4.196 0 7.201 5.697 2.955 10.079l-6.573 6.172-1.737 1.737c.335.182.71.281 1.094.281h.045c.564 0 1.109-.208 1.533-.587l.015-.014.016-.015 6.76-6.347.028-.027.028-.03c1.252-1.292 2.078-2.811 2.388-4.392a7.402 7.402 0 0 0-.441-4.323Z", fill: "currentColor" }) }))); };
exports.default = GSIconHeart;
